<template>
  <b-input-group>
    <input
      class="form-control col-md-12"
      v-model="value"
      :type="fieldType"
      :disabled="disabled"
      :maxlength="schema.max"
      :id="getFieldID(schema)"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
      :name="schema.inputName"
    >
    <b-input-group-append>
      <b-button @click="toggleType">
        <font-awesome-icon :icon="icon" title="Click to view password input."/>
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

library.add([faEye, faEyeSlash]);

export default {
  mixins: [abstractField],
  data() {
    return {
      fieldType: 'password',
    };
  },
  computed: {
    icon() {
      return this.fieldType === 'password' ? 'eye' : 'eye-slash';
    },
  },
  methods: {
    toggleType() {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldSmartPassword.vue